import { render, staticRenderFns } from "./PrintItemsList.vue?vue&type=template&id=0e1096db&scoped=true&"
import script from "./PrintItemsList.vue?vue&type=script&lang=js&"
export * from "./PrintItemsList.vue?vue&type=script&lang=js&"
import style0 from "./PrintItemsList.vue?vue&type=style&index=0&id=0e1096db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1096db",
  null
  
)

export default component.exports